import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';
import type Emitter from '@exodus/wild-emitter';

import type { PlaygroundSbtModule } from '../module/index.js';
import type { PlaygroundSbtAtom } from '../types.js';

type Dependencies = {
  playgroundSbtAtom: PlaygroundSbtAtom;
  playgroundSbt: PlaygroundSbtModule;
  port: Emitter;
};

const createPlaygroundSbtPlugin = ({
  port,
  playgroundSbt,
  playgroundSbtAtom,
}: Dependencies) => {
  const observer = createAtomObserver({
    atom: playgroundSbtAtom,
    port,
    event: 'playgroundSbt',
  });

  const onLoad = () => {
    observer.start();
    playgroundSbt.refresh();
  };

  const onStop = () => {
    observer.unregister();
  };

  return { onLoad, onStop };
};

const playgroundSbtPluginDefinition = {
  id: 'playgroundSbtPlugin',
  type: 'plugin',
  factory: createPlaygroundSbtPlugin,
  dependencies: ['port', 'playgroundSbt', 'playgroundSbtAtom'],
} as const satisfies Definition;

export default playgroundSbtPluginDefinition;
